import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  FlatList,
  Modal,
  Dimensions,
  PixelRatio,
  ScrollView,
  ActivityIndicator,
} from "react-native";
import React, { useEffect, useMemo, useState } from "react";
import Colours from "../../utils/Colours";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "react-native-responsive-screen";
import { LinearGradient } from "expo-linear-gradient";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import TopHeaderComponent from "../aTopHeader/TopHeaderComponent";
import ADoingScreen from "../aDoingScreen/ADoingScreen";
import ViewPublicCelebratoryPull from "../../ViewPublicCelebratoryPull/ViewPublicCelebratoryPull";
import ATablesComp from "../../aTablesComp/ATablesComp";
import UserProfileIcon from "../../icons/UserProfileIcon";
import FowardFlatArrow from "../../icons/FowardFlatArrow";
import GiveawayIcon from "../../icons/GiveawayIcon";
import useAuth from "../../hooks/useAuth";
import UpdateProfilePage from "../profileScreen/UpdateProfilePage";
import MyCityState from "../signInScreen/MyCityState";
import CheckInList from "../../icons/CheckInList";
import AsyncStorage from "@react-native-async-storage/async-storage";
import SuccessAlertComp from "../../alertComp/SuccessAlertComp";
import ErrorAlertComp from "../../alertComp/ErrorAlertComp";
import { Image } from "expo-image";
import Comments from "../../icons/Comments";
import AllHomeComp from "./AllHomeComp";
import PlacesBid from "../placesBid/PlacesBid";
import ShowsListPage from "../showsListPage/ShowsListPage";
import HigherTablesPage from "../higherTablesList/HigherTablesPage";
import BrandsHigherTablesPage from "../higherTablesList/BrandsHigherTablesPage";

//import axios from '../../api/axios';

const { width, height } = Dimensions.get("window");
const dpr = Math.round(PixelRatio.get() || 1);

// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;
const VAL_NAME = "dxfdmlk0f";
const MAX_RETRIEZ = 20;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const dynamicTablesThumbnailHeight = Math.round((width / BASE_WIDTH) * 60);
const dynamicTablesThumbnailWidth = Math.round((width / BASE_WIDTH) * 60);
const dynamicThumbnailWidth = Math.round((width * 22) / 100);
const dynamicThumbnailHeight = Math.round((height * 10) / 100);
const dynamicCreatedForThumbnailWidth = Math.round((width * 6) / 100);
const dynamicCreatedForThumbnailHeight = Math.round((width * 6) / 100);

const BodyHome = ({
  // higherTablesLocal,
  // topLocalCelebratories,
  yourRecentTablesArray = [],
  isLoadingTables = false,
  displayLimit,
}) => {
  const [showADoingsScreen, setShowADoingsScreen] = useState(false);
  const [reloadCityImageData, setReloadCityImageData] = useState(false);
  const [showMyCityState, setShowMyCityState] = useState(false);
  const [showUpdateProfilePage, setShowUpdateProfilePage] = useState(false);
  const [showViewPublicCelebratoryPull, setShowViewPublicCelebratoryPull] = useState(false);
  const [selectedTable, setSelectedTable] = useState(null);
  const [selectedCelebratory, setSelectedCelebratory] = useState(null);
  const [transactionRef, setTransactionRef] = useState(null);
  const [showMeezaTutorial, setShowMeezaTutorial] = useState(false);
  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);
  const [isSuccessCompVisible, setIsSuccessCompVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [hasCity, setHasCity] = useState(false);
  const [hasImages, setHasImages] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isVerifyLoading, setShowVerifyLoading] = useState(false);

  const [isAllVisible, setIsAllVisible] = useState(false);
  const [isBidVisible, setIsBidVisible] = useState(false);
  const [isPlacesVisible, setIsPlacesVisible] = useState(true);
  const [isShowsVisible, setIsShowsVisible] = useState(false);
  const [isHighTableVisible, setIsHighTableVisible] = useState(false);
  const [isCelebratoryVisible, setIsCelebratoryVisible] = useState(false);

  const [selected, setSelected] = useState();

  const [retryCount, setRetryCount] = useState(0);

  const [imageKey, setImageKey] = useState(0);

  const axiosPrivate = useAxiosPrivate();

  const { image } = useAuth();

  // ... Keep all your existing useState hooks here ...
  // Add a new state to track if a specific brand filter is active
  const [selectedBrand, setSelectedBrand] = useState(null);

  // 2. 🌟 DYNAMICALLY GENERATE TAGS ARRAY
  const tags = useMemo(() => {
    const staticTags = [{ tag: "Places" }, { tag: "Higher Tables" }];

    if (isLoadingTables || !yourRecentTablesArray || yourRecentTablesArray.length === 0) {
      return staticTags;
    }
    //console.log()

    // Extract unique active brand names safely
    // Pure JavaScript safe filtering
    const activeBrands = yourRecentTablesArray
      .map((table) => table.associatedBrand?.brandName || table.brandName)
      .filter((name) => Boolean(name)); // clears out undefined, null, or empty values

    const uniqueBrands = [...new Set(activeBrands)];

    // Map brands to tags objects
    const brandTags = uniqueBrands.map((brand) => ({ tag: brand, isBrand: true }));

    // Merge arrays: active dynamic brands go first!
    return [...brandTags, ...staticTags];
  }, [yourRecentTablesArray, isLoadingTables]);

  // Find the exact active table object matching the currently highlighted brand name
  const currentSelectedBrandData = useMemo(() => {
    if (!selectedBrand || !yourRecentTablesArray) return null;

    // Look for the first table object that matches the selected brand name
    return yourRecentTablesArray.find((table) => {
      const name = table.associatedBrand?.brandName || table.brandName;
      return name === selectedBrand;
    });
  }, [selectedBrand, yourRecentTablesArray]);

  // 3. 🌟 SET DEFAULT ACTIVE TAG ON FIRST MOUNT / VALUE CHANGES
  useEffect(() => {
    if (tags && tags.length > 0) {
      const defaultTag = tags[0].tag;
      setSelected(defaultTag);

      // If the first tag happens to be a dynamic brand, flag it as active
      if (tags[0].isBrand) {
        setSelectedBrand(defaultTag);
        setIsPlacesVisible(false);
        setIsHighTableVisible(false);
      } else {
        setSelectedBrand(null);
        handleSelectedItems(defaultTag);
      }
    }
  }, [tags]);
  useEffect(() => {
    const getTransactionRef = async () => {
      try {
        const savedRef = await AsyncStorage.getItem("currentTransactionRef");
        if (savedRef) {
          ////console.log("Retrieved transaction ref:", savedRef);
          setTransactionRef(savedRef); // save to state
        } else {
          ////console.log("No transaction ref found in storage.");
        }
      } catch (err) {
        //console.error("Error reading transaction ref:");
      }
    };

    getTransactionRef();
  }, [transactionRef]);

  // useEffect(() => {
  //   const handleCheckUserImagesAndCity = async () => {
  //     try {
  //       setIsLoading(true);
  //       const response = await axiosPrivate.get("/cityImageData/cityImageData");
  //       if (response.status === 200 || response.status === 201) {
  //         setHasCity(response.data?.hasCity);
  //         setHasImages(response.data?.hasImages);
  //       } else {
  //         ////console.log('ResponseDataError:***')
  //       }
  //     } catch (error) {
  //       if (error.response) {
  //         //console.error('Error response from server:', error.response.data?.error || error.response.data?.message || 'Something went wrong');
  //         //const errorMessages = error.response.data?.error || error.response.data?.message || 'Something went wrong';
  //         // setErrorMessage(errorMessages);
  //         //setIsErrorCompVisible(true);
  //       }
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  //   handleCheckUserImagesAndCity();

  //   // Refetch if reloadCityImageData turns true
  //   if (reloadCityImageData) {
  //     handleCheckUserImagesAndCity().finally(() => setReloadCityImageData(false));
  //   }
  // }, [reloadCityImageData]);

  // const handleSelectedItems = (selectedItem) => {
  //   setSelected(selectedItem);
  //   // if (selectedItem === "All") {
  //   //   setIsAllVisible(true);
  //   //   setIsBidVisible(false);
  // setIsPlacesVisible(false);
  //   //   setIsHighTableVisible(false);
  //   //   setIsCelebratoryVisible(false);
  //   //   setIsShowsVisible(false);
  //   // } else if (selectedItem === "Popular Bid") {
  //   //   setIsBidVisible(true);
  //   //   setIsAllVisible(false);
  //   //   setIsPlacesVisible(false);
  //   //   setIsHighTableVisible(false);
  //   //   setIsCelebratoryVisible(false);
  //   //   setIsShowsVisible(false);
  //   // } else
  //   if (selectedItem === "Higher Tables") {
  //     setIsHighTableVisible(true);
  //     setIsAllVisible(false);
  //     setIsPlacesVisible(false);
  //     setIsBidVisible(false);
  //     setIsCelebratoryVisible(false);
  //     setIsShowsVisible(false);
  //     // } else if (selectedItem === "Celebratories") {
  //     //   setIsCelebratoryVisible(true);
  //     //   setIsHighTableVisible(false);
  //     //   setIsPlacesVisible(false);
  //     //   setIsAllVisible(false);
  //     //   setIsBidVisible(false);
  //     //   setIsShowsVisible(false);
  //   } else if (selectedItem === "Places") {
  //     setIsPlacesVisible(true);
  //     setIsCelebratoryVisible(false);
  //     setIsHighTableVisible(false);
  //     setIsAllVisible(false);
  //     setIsBidVisible(false);
  //     setIsShowsVisible(false);
  //   }
  //   // else if (selectedItem === "Shows") {
  //   //   setIsShowsVisible(true);
  //   //   setIsPlacesVisible(false);
  //   //   setIsCelebratoryVisible(false);
  //   //   setIsHighTableVisible(false);
  //   //   setIsAllVisible(false);
  //   //   setIsBidVisible(false);
  //   // }
  //   else {
  //     // setIsAllVisible(true);
  //     setIsPlacesVisible(true);
  //   }
  // };

  // 4. UPDATE SELECTION SWITCH LOGIC

  const handleSelectedItems = (selectedItem) => {
    setSelected(selectedItem);

    // Check if the clicked tag belongs to one of the dynamic brands
    const clickedTagObject = tags.find((t) => t.tag === selectedItem);

    if (clickedTagObject?.isBrand) {
      setSelectedBrand(selectedItem);
      setIsHighTableVisible(false);
      setIsAllVisible(false);
      setIsPlacesVisible(false);
      setIsBidVisible(false);
      setIsCelebratoryVisible(false);
      setIsShowsVisible(false);
    } else if (selectedItem === "Higher Tables") {
      setSelectedBrand(null);
      setIsHighTableVisible(true);
      setIsAllVisible(false);
      setIsPlacesVisible(false);
      setIsBidVisible(false);
      setIsCelebratoryVisible(false);
      setIsShowsVisible(false);
    } else if (selectedItem === "Places") {
      setSelectedBrand(null);
      setIsPlacesVisible(true);
      setIsCelebratoryVisible(false);
      setIsHighTableVisible(false);
      setIsAllVisible(false);
      setIsBidVisible(false);
      setIsShowsVisible(false);
    } else {
      setSelectedBrand(null);
      setIsPlacesVisible(true);
    }
  };

  const getOptimizedCloudinaryUrl = (originalUrl, targetWidth, targetHeight) => {
    if (!originalUrl || !originalUrl.includes(VAL_NAME)) {
      return originalUrl;
    }

    // The 'transformations' string includes the optimization flags
    const transformations = `w_${targetWidth},h_${targetHeight},c_fill,f_auto,q_90,dpr_${dpr}`;

    // Inject the transformations into the URL
    return originalUrl.replace(/upload\//, `upload/${transformations}/`);
  };

  const handleImageError = () => {
    if (retryCount < MAX_RETRIEZ) {
      // Increment the retry counter
      setRetryCount((prevCount) => prevCount + 1);

      // Force component re-render by changing the key
      setImageKey((prevKey) => prevKey + 1);

      ////console.log(`Image failed to load. Retrying... Attempt ${retryCount + 1}`);
    } else {
      // Log final failure or set a state to show a permanent fallback icon
      ////console.log('Image failed to load after maximum retries.');
    }
  };

  const handleViewHigherTable = (table) => {
    setSelectedTable(table);
    setShowADoingsScreen(true);
    ////console.log("Selected Table:", table);
  };
  const handleViewCelebratoryPulls = (selectedCelebratory) => {
    setSelectedCelebratory(selectedCelebratory);
    ////console.log('selectedCelebratory', selectedCelebratory)
    setShowViewPublicCelebratoryPull(true);
  };

  const verifyPaymentWithReference = async () => {
    setShowVerifyLoading(true);

    try {
      const reference = await AsyncStorage.getItem("currentTransactionRef");
      ////console.log('reference', reference)

      if (reference) {
        const response = await axiosPrivate.get(
          `/verifyTransaction/verifyTransaction/${reference}`,
        );
        if (response.data.status === "success") {
          // update balance, close modal, etc.
          await AsyncStorage.removeItem("currentTransactionRef");
          setSuccessMessage("Your transaction was successfull");
          setIsSuccessCompVisible(true);
        } else if (response.data.status === "failed") {
          await AsyncStorage.removeItem("currentTransactionRef");
          setErrorMessage("Sorry transaction failed");
          setIsErrorCompVisible(true);
        } else {
          await AsyncStorage.removeItem("currentTransactionRef");
          setTransactionRef(null);
        }
      } else {
        ////console.log('No saved reference')
      }
    } catch (error) {
      ////console.log('Error Handling Transaction')
      setNoticeMessage("You are about to close this page");
      setShowNoticeAlertComp(true);
    } finally {
      setShowVerifyLoading(false);
    }
  };

  const tagColors = {
    Birthday: "#FF5733",
    Beauty: "#d98ffcff",
    "Massive Love": "#33B5FF",
    "Supper fan": "#33FF57",
    Friendship: "#FFC300",
    Appreciation: "#C70039",
    Engagement: "#900C3F",
    Wedding: "#008080",
    Anniversary: "#FF1493",
    Graduation: "#A52A2A",
    Growth: "#4B0082",
    Congratulatory: "#581845",
    "Others...": "#2E8B57",
  };

  // Default function to get tag color (fallback color if tag is missing in the object)
  const getTagColor = (tag) => {
    return tagColors[tag] || "#808080"; // Default gray color for unknown tags
  };

  if (isLoading) {
    return (
      <View style={styles.loaderContainer}>
        <ActivityIndicator size="large" color={Colours.PRIMARY} />
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <View style={styles.nightlifeStyles}>
        <Text style={styles.headerText}>Doings Trend</Text>
        {/* <Text style={styles.subHeaderText}>MY CITY</Text> */}
      </View>
      {transactionRef && (
        <TouchableOpacity
          style={styles.profileDataContainer2}
          //  onPress={() => setShowMyCityState(true)}
          onPress={() => verifyPaymentWithReference()}
        >
          <View style={styles.profileDataSubContainer}>
            <CheckInList color={Colours.PRIMARY} height={dynamicSize(25)} width={dynamicSize(25)} />
            <View style={styles.flatArrowContainer}>
              {/* <Text style={styles.textTxt}>Check last transaction status </Text> */}
              <Text style={styles.textTxt}>Check-in purchased ticket </Text>
              {isVerifyLoading ? (
                <ActivityIndicator size="small" color={Colours.PRIMARY} />
              ) : (
                <FowardFlatArrow color={Colours.PRIMARY} />
              )}
            </View>
          </View>
        </TouchableOpacity>
      )}

      {/* <View
        style={{
          // height: dynamicSize(40),
          //  marginTop: dynamicSpacing(15),
          // paddingLeft: dynamicSpacing(10),
          // paddingRight: dynamicSpacing(10),
          marginBottom: dynamicSpacing(20),
        }}
      >
        <FlatList
          data={tags}
          horizontal={true}
          showsHorizontalScrollIndicator={false}
          renderItem={({ item, index }) => (
            <TouchableOpacity
              style={{
                display: "flex",
                // backgroundColor: "blue",
                marginRight: dynamicSpacing(5),
                marginBottom: dynamicSpacing(5),
              }}
              onPress={() => handleSelectedItems(item.tag)}
            >
              <Text
                style={[
                  { fontFamily: "Sen-Regular" },
                  selected == item.tag ? styles.selectedTable : styles.unselectedTable,
                ]}
              >
                {item.tag}
              </Text>
            </TouchableOpacity>
          )}
        />
      </View> */}

      {/* TAGS SCROLLER */}
      <View style={{ marginBottom: dynamicSpacing(20) }}>
        <FlatList
          data={tags}
          horizontal={true}
          showsHorizontalScrollIndicator={false}
          keyExtractor={(item, index) => item.tag + index}
          renderItem={({ item }) => (
            <TouchableOpacity
              style={{
                display: "flex",
                marginRight: dynamicSpacing(5),
                marginBottom: dynamicSpacing(5),
              }}
              onPress={() => handleSelectedItems(item.tag)}
            >
              <Text
                style={[
                  { fontFamily: "Sen-Regular" },
                  selected === item.tag ? styles.selectedTable : styles.unselectedTable,
                ]}
              >
                {item.tag}
              </Text>
            </TouchableOpacity>
          )}
        />
      </View>

      {/* {isAllVisible && selectedBrand === null && (
        <AllHomeComp
          higherTablesLocal={higherTablesLocal}
          topLocalCelebratories={topLocalCelebratories}
          hasCity={hasCity}
          hasImages={hasImages}
          getOptimizedCloudinaryUrl={getOptimizedCloudinaryUrl}
          handleImageError={handleImageError}
          handleViewHigherTable={handleViewHigherTable}
          handleViewCelebratoryPulls={handleViewCelebratoryPulls}
          tagColors={tagColors}
          getTagColor={getTagColor}
        />
      )} */}
      {selectedBrand !== null && (
        <BrandsHigherTablesPage
          displayLimit={displayLimit}
          brandName={selectedBrand}
          brandImage={
            currentSelectedBrandData?.associatedBrand?.image ||
            currentSelectedBrandData?.image ||
            null
          }
          brandId={currentSelectedBrandData?.associatedBrand?._id}
        />
      )}
      {isPlacesVisible && selectedBrand === null && <PlacesBid />}
      {/* {isShowsVisible && <ShowsListPage />} */}
      {isHighTableVisible && selectedBrand === null && <HigherTablesPage />}

      <Modal
        animationType="slide"
        visible={showADoingsScreen}
        onRequestClose={() => setShowADoingsScreen(false)}
      >
        <TopHeaderComponent headerText={"Table"} hideScreen={() => setShowADoingsScreen(false)} />
        <View style={{ backgroundColor: Colours.LIGHTEST }}>
          <ADoingScreen selectedTable={selectedTable} />
        </View>
      </Modal>
      <Modal
        animationType="slide"
        visible={showViewPublicCelebratoryPull}
        onRequestClose={() => setShowViewPublicCelebratoryPull(false)}
      >
        <TopHeaderComponent
          headerText={selectedCelebratory?.celebratoryCaption}
          hideScreen={() => setShowViewPublicCelebratoryPull(false)}
        />
        <View style={{ backgroundColor: Colours.LIGHTEST }}>
          <ViewPublicCelebratoryPull selectedCelebratory={selectedCelebratory} />
        </View>
      </Modal>

      <Modal
        animationType="slide"
        visible={showUpdateProfilePage}
        onRequestClose={() => setShowUpdateProfilePage(false)}
      >
        <TopHeaderComponent
          headerText={"Update your profile"}
          hideScreen={() => setShowUpdateProfilePage(false)}
        />
        <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
            paddingBottom: 100,
            backgroundColor: Colours.LIGHTEST,
          }}
        >
          <UpdateProfilePage
            initialImage={image}
            fromHomePage={true}
            setReloadCityImageData={setReloadCityImageData}
            setShowUpdateProfilePage={setShowUpdateProfilePage}
          />
        </ScrollView>
      </Modal>

      <Modal
        animationType="slide"
        visible={showMyCityState}
        onRequestClose={() => setShowMyCityState(false)}
      >
        <TopHeaderComponent
          headerText={"Setup your city"}
          hideScreen={() => setShowMyCityState(false)}
        />
        {/* <ScrollView contentContainerStyle={{ flexGrow: 1, paddingBottom: 100, backgroundColor: Colours.LIGHTEST }}> */}
        <MyCityState
          fromSettings={true}
          fromHomePage={true}
          setReloadCityImageData={setReloadCityImageData}
          setShowMyCityState={setShowMyCityState}
        />
        {/* </ScrollView> */}
      </Modal>

      <Modal visible={isSuccessCompVisible} transparent={true} animationType="fade">
        <SuccessAlertComp
          message={successMessage}
          onClose={() => {
            setTransactionRef(null);
            setIsSuccessCompVisible(false);
          }}
        />
      </Modal>

      <Modal visible={isErrorCompVisible} transparent={true} animationType="fade">
        <ErrorAlertComp
          message={errorMessage}
          onClose={() => {
            setTransactionRef(null);
            setIsErrorCompVisible(false);
          }}
        />
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 15,
    backgroundColor: Colours.LIGHTEST,
  },
  nightlifeStyles: {
    alignItems: "center",
    paddingVertical: 15,
  },
  emptyspaceStyle: {
    display: "flex",
    flexDirection: "row",
  },
  loaderContainer: {
    flex: 1,
    marginTop: dynamicSpacing(10),
    backgroundColor: Colours.LIGHTEST, // optional
  },
  picImageContr: {
    height: dynamicSize(60),
    width: dynamicSize(60),
    borderRadius: dynamicSize(15),
    marginRight: dynamicSpacing(10),
    marginTop: dynamicSpacing(5),
  },

  profileDataContainer: {
    display: "flex",
    backgroundColor: "white",
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(10),
    marginBottom: dynamicSpacing(10),
  },

  selectedTable: {
    padding: dynamicSpacing(10),
    borderWidth: 1,
    borderColor: Colours.PRIMARY,
    backgroundColor: Colours.PRIMARY,
    borderRadius: dynamicSize(50),
    paddingHorizontal: dynamicSize(18),
    color: "#FFFFFF",
  },
  unselectedTable: {
    padding: dynamicSpacing(10),
    borderWidth: 1,
    // borderColor: Colours.PRIMARY,
    borderColor: Colours.DARKLIGHTGRAY,
    borderRadius: dynamicSize(50),
    paddingHorizontal: dynamicSize(18),
    //color: Colours.PRIMARY,
    color: Colours.DARKLIGHTGRAY,
  },

  profileDataContainer2: {
    display: "flex",
    backgroundColor: Colours.PRIMARY_LIGHTER,
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(10),
    marginBottom: dynamicSpacing(10),
  },

  profileDataSubContainer: {
    display: "flex",
    flexDirection: "row",
    gap: dynamicSpacing(10),
    alignItems: "center",
  },
  flatArrowContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: dynamicSize(280),
    //width: '100%',
  },
  comments1: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: dynamicSpacing(5),
    //  color: Colours.DARKLIGHTGRAY,
  },
  comments2: {
    fontSize: dynamicFontSize(13),
    color: Colours.PRIMARY_LIGHT,
    fontFamily: "Sen-Regular",
  },

  textDescInputStyle: {
    height: dynamicSize(85),
    marginBottom: dynamicSpacing(10),
    // gap: 10,
    padding: dynamicSpacing(15),
    borderWidth: dynamicSize(1),
    borderColor: Colours.LIGHTGRAY,
    borderRadius: dynamicSize(15),
    fontFamily: "Sen-Regular",
    fontSize: dynamicSize(15),
    verticalAlign: "top",
    backgroundColor: Colours.LIGHTGRAY,
  },
  focusedBorder: {
    borderColor: Colours.PRIMARY,
  },
  textTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Bold",
  },

  headerText: {
    // fontSize: 16,
    fontSize: dynamicFontSize(18),
    color: Colours.DARKGRAY,
    fontFamily: "Sen-Bold",
  },
  tutorialTxt: {
    fontSize: dynamicFontSize(17),
    color: "white",
    fontFamily: "Sen-Bold",
    textAlign: "center",
  },
  tutorialView: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: "100%",
  },
  subHeaderText: {
    // fontSize: 12,
    fontSize: dynamicFontSize(12),
    color: Colours.PRIMARY,
    fontFamily: "Sen-Regular",
  },
  bodyContainer: {
    marginVertical: 10,
    padding: 15,
    backgroundColor: "white",
    borderRadius: 15,
  },
  bodyContainer2: {
    display: "flex",
    height: dynamicSize(50),
    marginVertical: dynamicSpacing(15),
    // padding: dynamicSpacing(15),
    backgroundColor: "white",
    borderRadius: dynamicSize(15),
  },
  tutImg: {
    height: "100%",
    width: "100%",
    borderRadius: dynamicSize(15),
    zIndex: 7,
  },
  gradientOverlay: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    borderRadius: dynamicSize(15),
    zIndex: 8,
    height: "100%",
    width: "100%",
  },
  sectionTitle: {
    // fontSize: 12,
    fontSize: dynamicFontSize(12),
    color: Colours.PRIMARY,
    fontFamily: "Sen-Regular",
    marginBottom: 10,
  },
  tablesListContainer: {
    paddingBottom: 10,
    marginBottom: 10,
    gap: 5,
    borderBottomWidth: 1,
    borderBottomColor: Colours.LIGHTGRAY,
  },
  tableName: {
    color: Colours.DARKGRAY,
    // fontSize: 15,
    fontSize: dynamicFontSize(16),
    fontFamily: "Sen-Bold",
  },
  tableValueContainer: {
    flexDirection: "row",
    // justifyContent: 'space-between',
    alignItems: "center",
    width: width * 0.4, // Responsive width
    gap: dynamicSpacing(8),
  },
  tableValueLabel: {
    color: Colours.DARKLIGHTGRAY,
    // fontSize: 12,
    fontSize: dynamicFontSize(13),
    fontFamily: "Sen-Regular",
  },
  tableValue: {
    color: Colours.PRIMARY_LIGHT,
    fontFamily: "Sen-Bold",
    // fontSize: 16,
    fontSize: dynamicFontSize(16),
  },
  tablesListContainer2: {
    paddingBottom: 10,
    gap: 5,
  },
  tableListTitlesContain: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  eventName: {
    color: Colours.DARKGRAY,
    // fontSize: 15,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Bold",
    width: width * 0.5, // Responsive width
  },
  eventCategory: {
    color: Colours.DARKLIGHTGRAY,
    paddingTop: 10,
    // fontSize: 12,
    fontSize: dynamicFontSize(12),
    fontFamily: "Sen-Regular",
  },
  divider: {
    height: 1,
    backgroundColor: Colours.LIGHTGRAY,
    marginVertical: 10,
  },
  partyImgSmall: {
    width: width * 0.2, // Responsive size
    height: width * 0.15,
    borderRadius: 10,
  },
  giverHeaders: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  modalContainer: {
    flex: 1,
    backgroundColor: Colours.LIGHTEST,
  },

  itemContainer: {
    paddingVertical: hp(1.5),
    borderBottomWidth: 1,
    borderBottomColor: Colours.LIGHTGRAY,
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  flexColumn: {
    flex: 1,
    marginRight: wp(3),
  },
  itemTitle: {
    fontSize: dynamicFontSize(16),
    color: Colours.DARKGRAY,
    fontFamily: "Sen-Bold",
  },
  tagsContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: hp(0.5),
  },
  tag: {
    paddingHorizontal: wp(2),
    paddingVertical: hp(0.5),
    borderRadius: wp(3),
    marginRight: wp(1),
    marginBottom: wp(1),
  },
  tagText: {
    fontSize: dynamicFontSize(10),
    fontFamily: "Sen-Regular",
    color: "white",
  },
  creatorContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: hp(0.5),
  },
  valueLabel: {
    fontSize: dynamicFontSize(13),
    color: Colours.DARKLIGHTGRAY,
    fontFamily: "Sen-Regular",
  },
  profileImage: {
    width: wp(6),
    height: wp(6),
    borderRadius: wp(6),
    marginLeft: wp(1),
  },
  creatorName: {
    fontSize: dynamicFontSize(14),
    color: Colours.PRIMARY,
    fontFamily: "Sen-Regular",
    marginLeft: wp(1),
  },
  thumbnail: {
    width: wp(22),
    height: hp(10),
    borderRadius: wp(3),
  },
});

export default BodyHome;
